import ItemForSaleModal from '../Modal/ItemForSaleModal';
import { parseCurrency } from '../../../utils/SamuiUtils';

const ItemForSaleTable = ({
    formDetailList,
    handleChangeDetail,
    handleRemoveRow,
    formatCurrency,
    showItemModal,
    handleItemClose,
    itemDataList,
    onRowSelectItem,
    handleItemShow,
    whDataList,
    showWarehouseModal,
    handleWarehouseClose,
    handleWarehouseShow,
    onRowSelectWh,
    handleFocus,
    handleBlur,
    disabledRec,
    disabled,
    isQuotation,
    docType,
    docStatus,
    mode,
    showAllItems,
    handleShowAllItems,
    itemPriceType,
    setItemPriceType
}) => {
    // ถ้าเป็นหน้าใบสั่งซื้อและใบรับสินค้า ให้แสดง Column จำนวนรับ / จำนวนค้างรับ
    const isPurchaseOrderOrReceipt = () => {
        return window.location.pathname === '/purchase-order' || window.location.pathname === '/purchase-receipt';
    };

    // ถ้าเป็นหน้าใบสั่งซื้อและใบรับสินค้า ให้กำหนด Width จำนวนรับ / จำนวนค้างรับ
    const getColumnWidth = () => {
        if (window.location.pathname === '/purchase-order') {
            return '13%';
        } else if (window.location.pathname === '/purchase-receipt') {
            return '21%';
        } else {
            return '21%';
        }
    };

    return (
        <div className="col-12">
            <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h4 className="card-title">รายละเอียดสินค้า</h4>
                    <div className="d-flex align-items-center">
                        {window.location.pathname === '/purchase-request' && localStorage.getItem("company") === "2" && (
                            <div className="d-flex align-items-center me-3">
                                <input
                                    type="checkbox"
                                    id="showAllItems"
                                    checked={showAllItems}
                                    onChange={async () => {
                                        await handleShowAllItems(!showAllItems);
                                    }}
                                    style={{ marginRight: "6px", width: "18px", height: "18px", cursor: "pointer" }}
                                />
                                <label
                                    htmlFor="showAllItems"
                                    style={{ userSelect: "none", cursor: "pointer", fontWeight: "500" }}
                                >
                                    แสดงไอเทมทั้งหมด
                                </label>
                            </div>
                        )}
                        <button
                            className="btn text-white"
                            onClick={handleItemShow}
                            style={{
                                backgroundColor: "rgb(239, 108, 0)",
                                whiteSpace: "nowrap",
                                padding: "10px 16px",
                                fontSize: "15px",
                                borderRadius: "4px",
                                boxShadow: "0 2px 6px rgba(239,108,0,0.6)",
                                transition: "background-color 0.3s ease",
                                cursor: disabled ? "not-allowed" : "pointer",
                            }}
                            disabled={disabled}
                            onMouseEnter={(e) => !disabled && (e.currentTarget.style.backgroundColor = "rgb(210, 95, 0)")}
                            onMouseLeave={(e) => !disabled && (e.currentTarget.style.backgroundColor = "rgb(239, 108, 0)")}
                        >
                            <i className="fa fa-plus" style={{ marginRight: "6px" }}></i> เพิ่มรายการ
                        </button>
                    </div>
                </div>
                <ItemForSaleModal
                    formDetailList={formDetailList}
                    showItemModal={showItemModal}
                    handleItemClose={handleItemClose}
                    itemDataList={itemDataList}
                    onRowSelectItem={onRowSelectItem}
                    itemPriceType={itemPriceType}
                    setItemPriceType={setItemPriceType}
                />
                <div className="card-body">
                    <div className="table-responsive" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                        <table id="basic-datatables" className="table table-striped table-hover">
                            <thead className="thead-dark">
                                <tr>
                                    <th className="text-center" style={{ width: '1%' }}>#</th>
                                    <th className="text-center" style={{ width: '10%' }}>รหัสสินค้า</th>
                                    <th
                                        className="text-center"
                                        style={window.location.pathname === '/purchase-order' ? { width: '12%' } : { width: '20%' }}>
                                        ชื่อสินค้า
                                    </th>
                                    {
                                        (window.location.pathname === '/purchase-request' ||
                                            window.location.pathname === '/purchase-order' ||
                                            window.location.pathname === '/product-receipt')
                                        && (
                                            <th
                                                className="text-center"
                                                style={{
                                                    width: "15%",
                                                }}
                                            >
                                                หมายเหตุ
                                            </th>
                                        )
                                    }
                                    <th className="text-center"
                                        hidden={window.location.pathname === '/billofsale'
                                            || window.location.pathname === '/bill'
                                            // || window.location.pathname === '/order-product'
                                            || window.location.pathname === '/picking-list'
                                            ? false : true}
                                        style={{ width: '12%' }}
                                    >
                                        คลังสินค้า
                                        <i
                                            onClick={handleWarehouseShow}
                                            className="fa fa-search-plus"
                                            style={{
                                                position: 'absolute',
                                                cursor: 'pointer',
                                                fontSize: '18px',
                                                marginLeft: '35px',
                                            }}
                                            hidden={
                                                disabled
                                                || window.location.pathname === '/bill'
                                                || window.location.pathname === '/picking-list'
                                                || (window.location.pathname === '/billofsale' && mode === 'U')
                                            }
                                        />
                                    </th>
                                    <th hidden={window.location.pathname === '/billofsale'
                                        || window.location.pathname === '/bill'
                                        // || window.location.pathname === '/order-product'
                                        || window.location.pathname === '/picking-list'
                                        ? false : true}
                                        className="text-center"
                                        style={{ width: '8%' }}>
                                        จำนวนคงคลัง
                                    </th>
                                    <th className="text-center"
                                        style={{ width: '8%' }}>
                                        จำนวน
                                        {window.location.pathname === '/billofsale' || window.location.pathname === '/bill' ? 'ขาย' : ''}
                                        {window.location.pathname === '/order-product' ? 'ออเดอร์' : ''}
                                        {window.location.pathname === '/picking-list' ? 'ออเดอร์' : ''}
                                        {window.location.pathname === '/purchase-order' ? '(PO)' : ''}
                                    </th>
                                    {!isQuotation && (
                                        <th hidden={window.location.pathname === '/purchase-order' || window.location.pathname === '/quotation' ? false : true}
                                            className="text-center"
                                            style={{ width: '8%' }}>
                                            จำนวน{window.location.pathname === '/quotation' ? 'ส่ง' : 'รับ'}
                                        </th>
                                    )}
                                    <th hidden={!isPurchaseOrderOrReceipt()}
                                        className="text-center"
                                        style={{ width: '8%' }}>
                                        จำนวนค้างรับ {window.location.pathname === '/purchase-order' ? '(PO)' : ''}
                                    </th>
                                    <th className="text-center" style={{ width: '6%' }}>หน่วย</th>
                                    <th
                                        hidden={window.location.pathname === '/order-product'
                                            || window.location.pathname === '/picking-list' ? true : false}
                                        className="text-center"
                                        style={{ width: '8%' }}
                                    >
                                        ราคาต่อหน่วย
                                    </th>
                                    <th
                                        hidden={window.location.pathname === '/order-product'
                                            || window.location.pathname === '/picking-list' ? true : false}
                                        className="text-center"
                                        style={{ width: '8%' }}
                                    >
                                        ส่วนลด
                                    </th>
                                    <th
                                        hidden={window.location.pathname === '/order-product'
                                            || window.location.pathname === '/picking-list' ? true : false}
                                        className="text-center"
                                        style={{ width: '5%' }}
                                    >
                                        %
                                    </th>
                                    <th
                                        hidden={window.location.pathname === '/order-product'
                                            || window.location.pathname === '/picking-list' ? true : false}
                                        className="text-center"
                                        style={
                                            window.location.pathname === '/deposit-document' ||
                                                window.location.pathname === '/purchase-request' ||
                                                window.location.pathname === '/purchase-order' ?
                                                { width: '10%' } : { width: '7%' }}
                                    >
                                        จำนวนเงินรวม
                                    </th>
                                    <th className="text-center"
                                        style={{ width: getColumnWidth() }}
                                        hidden={window.location.pathname === '/deposit-document' ||
                                            window.location.pathname === '/purchase-request' ||
                                            window.location.pathname === '/purchase-order' ||
                                            window.location.pathname === '/billofsale' ||
                                            window.location.pathname === '/bill' ||
                                            window.location.pathname === '/order-product' ||
                                            window.location.pathname === '/picking-list' ||
                                            window.location.pathname === '/quotation' ||
                                            window.location.pathname === '/taxes'}
                                    >
                                        คลังสินค้า
                                        <i
                                            onClick={handleWarehouseShow}
                                            className="fa fa-search-plus"
                                            style={{
                                                position: 'absolute',
                                                cursor: 'pointer',
                                                fontSize: '18px',
                                                marginLeft: '35px',
                                            }}
                                            hidden={(window.location.pathname === '/product-receipt' && mode === 'I') ? false : true}
                                        />
                                    </th>
                                    {/* <th
                                        className="text-center"
                                        style={{ width: '6%' }}
                                        hidden={window.location.pathname === '/quotation' ||
                                            window.location.pathname === '/order-product' ||
                                            window.location.pathname === '/billofsale'
                                            ? false : true}>
                                        แก้ไข
                                    </th> */}
                                    <th
                                        className="text-center"
                                        style={{ width: '3%' }}
                                        hidden={window.location.pathname === '/product-receipt' ? true : false}>
                                        ลบ
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {formDetailList.length > 0 ? (
                                    formDetailList.map((item, index) => (
                                        <tr key={item.itemId || index + 1}>
                                            {/* # */}
                                            <td className="text-center">{index + 1}</td>

                                            {/* รหัสสินค้า */}
                                            <td className="text-center">
                                                <span>{item.itemCode || ''}</span>
                                            </td>

                                            {/* ชื่อสินค้า */}
                                            <td className="text-left">
                                                <span>{item.itemName || ''}</span>
                                            </td>

                                            {/* หมายเหตุ */}
                                            {
                                                (window.location.pathname === '/purchase-request' ||
                                                    window.location.pathname === '/purchase-order' ||
                                                    window.location.pathname === '/product-receipt') && (
                                                    <td className="text-left">
                                                        <input
                                                            type="text"
                                                            className="form-control text-left"
                                                            value={item.itemDesc || ""}
                                                            onChange={(e) =>
                                                                handleChangeDetail(
                                                                    index,
                                                                    "itemDesc",
                                                                    e.target.value
                                                                )
                                                            }
                                                            disabled={
                                                                (window.location.pathname === '/purchase-order' && docStatus === 4) ||
                                                                (window.location.pathname === '/product-receipt' && disabledRec) ||
                                                                (window.location.pathname !== '/product-receipt' && disabled)
                                                            }
                                                        />
                                                    </td>
                                                )
                                            }

                                            {/* คลังสินค้า */}
                                            <td className="text-center"
                                                hidden={window.location.pathname === '/billofsale'
                                                    || window.location.pathname === '/bill'
                                                    || window.location.pathname === '/picking-list'
                                                    ? false : true
                                                }>
                                                <select
                                                    name="whId"
                                                    value={item.whId || ''}
                                                    onChange={(e) => handleChangeDetail(index, 'whId', e.target.value)}
                                                    className="form-select form-control"
                                                    disabled={window.location.pathname === '/product-receipt'
                                                        ? (!disabled || disabledRec ? true : false) :
                                                        disabled
                                                    }
                                                >
                                                    <option value={''}>กรุณาเลือกคลัง</option>
                                                    {whDataList.map((warehouse) => (
                                                        <option key={warehouse.WH_Id} value={warehouse.WH_Id}>
                                                            {warehouse.WH_Name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </td>

                                            {/* จำนวนคงคลัง */}
                                            <td
                                                hidden=
                                                {
                                                    window.location.pathname === '/billofsale'
                                                        || window.location.pathname === '/bill'
                                                        || window.location.pathname === '/picking-list'
                                                        ? false : true
                                                }
                                                className="text-center"
                                            >
                                                {item.itemOnHand === "-" || item.itemOnHand === null ? ( // ถ้า loading เป็น true หรือ itemOnHand ไม่มีค่า
                                                    // <i className="fa fa-spinner fa-spin"></i>
                                                    <span>-</span>
                                                ) : (
                                                    <span>{formatCurrency(item.itemOnHand) || 0}</span>
                                                )}
                                            </td>

                                            {/* จำนวน */}
                                            <td className="text-center">
                                                <input
                                                    type="text"
                                                    className="form-control text-center"
                                                    value={item.itemQty || ''}
                                                    onChange={(e) => handleChangeDetail(index, 'itemQty', e.target.value)}
                                                    onFocus={(e) => handleFocus(index, 'itemQty')}
                                                    onBlur={(e) => handleBlur(index, 'itemQty', e.target.value)}
                                                    disabled={window.location.pathname === '/product-receipt'
                                                        ? (!disabled || disabledRec ? true : false) : disabled}
                                                    onInput={(e) => {
                                                        const inputValue = e.target.value;
                                                        if (!/^(0|[1-9]\d*)(\.\d*)?$/.test(inputValue)) {
                                                            e.target.value = inputValue.slice(0, -1);
                                                        }
                                                    }}
                                                />
                                            </td>

                                            {/* จำนวนรับ */}
                                            {!isQuotation && (
                                                <td
                                                    hidden={window.location.pathname === '/purchase-order' || window.location.pathname === '/quotation' ? false : true}
                                                    className="text-center"
                                                >
                                                    <input
                                                        type="text"
                                                        className="form-control text-center"
                                                        value={item.itemRecQty || 0}
                                                        onChange={(e) => handleChangeDetail(index, 'itemRecQty', e.target.value)}
                                                        disabled={disabled}
                                                        onInput={(e) => {
                                                            if (/^0+/.test(e.target.value)) {
                                                                e.target.value = e.target.value.replace(/^0+/, '');

                                                                // หากกรอกเฉพาะจุดทศนิยม ให้เติม 0 ด้านหน้า (เช่น .5 -> 0.5)
                                                                if (e.target.value.startsWith(".")) {
                                                                    e.target.value = "0" + e.target.value;
                                                                }
                                                            }
                                                        }}
                                                    />
                                                </td>
                                            )}

                                            {/* จำนวนค้างรับ */}
                                            <td
                                                hidden={!isPurchaseOrderOrReceipt()}
                                                className="text-center">
                                                <input
                                                    type="text"
                                                    className="form-control text-center"
                                                    value={item.itemRecBalance || 0}
                                                    onChange={(e) => handleChangeDetail(index, 'itemRecBalance', e.target.value)}
                                                    disabled={disabled}
                                                    onInput={(e) => {
                                                        if (/^0+/.test(e.target.value)) {
                                                            const inputValue = e.target.value;

                                                            // หากกรอกเฉพาะจุดทศนิยม ให้เติม 0 ด้านหน้า (เช่น .5 -> 0.5)
                                                            if (inputValue.startsWith(".") && inputValue !== ".") {
                                                                e.target.value = "0" + inputValue;
                                                            }
                                                        }
                                                    }}
                                                />
                                            </td>

                                            {/* หน่วย */}
                                            <td className="text-center">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={item.itemUnit || ''}
                                                    disabled={true}
                                                    onChange={(e) => handleChangeDetail(index, 'itemUnit', e.target.value)}
                                                />
                                            </td>

                                            {/* ราคาต่อหน่วย */}
                                            <td
                                                hidden={window.location.pathname === '/order-product'
                                                    || window.location.pathname === '/picking-list' ? true : false}
                                                className="text-end"
                                            >
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <input
                                                        type="text"
                                                        className="form-control text-end"
                                                        value={item.itemPriceUnit || ''}
                                                        onChange={(e) => handleChangeDetail(index, 'itemPriceUnit', e.target.value)}
                                                        onFocus={(e) => handleFocus(index, 'itemPriceUnit')}
                                                        onBlur={(e) => handleBlur(index, 'itemPriceUnit', e.target.value)}
                                                        // ปลดล็อกเรื่อง docType ให้พี่ดาด้า
                                                        // disabled={window.location.pathname === '/purchase-order'
                                                        //     ? (docType === 1 || docType === 2)
                                                        //         ? docStatus === 4 ? true : false : true
                                                        //     : disabled
                                                        // }
                                                        disabled={
                                                            window.location.pathname === '/purchase-order'
                                                                ? docStatus === 4
                                                                : disabled
                                                        }
                                                        onInput={(e) => {
                                                            const inputValue = e.target.value;
                                                            if (!/^(0|[1-9]\d*)(\.\d*)?$/.test(inputValue)) {
                                                                e.target.value = inputValue.slice(0, -1);
                                                            }
                                                        }}
                                                        style={{ flex: 1 }}
                                                    />
                                                    {window.location.pathname === '/purchase-order' && (docType === 1 || docType === 2) && docStatus !== 4 && (
                                                        <span
                                                            style={{ marginLeft: '8px', cursor: 'pointer' }}>
                                                            <i className='fa fa-undo' style={{ color: '#EF6C00' }}
                                                                onClick={() => {
                                                                    handleChangeDetail(index, 'itemPriceUnit', parseCurrency(item.itemPriceUnitOld));
                                                                    setTimeout(() => {
                                                                        handleBlur(index, 'itemPriceUnit', String(item.itemPriceUnitOld));
                                                                    }, 0);
                                                                }}
                                                            />
                                                        </span>
                                                    )}
                                                </div>
                                            </td>

                                            {/* ส่วนลด */}
                                            <td
                                                hidden={window.location.pathname === '/order-product'
                                                    || window.location.pathname === '/picking-list' ? true : false}
                                                className="text-end"
                                            >
                                                <input
                                                    type="text"
                                                    className="form-control text-end"
                                                    value={item.itemDiscount || ''}
                                                    onChange={(e) => handleChangeDetail(index, 'itemDiscount', e.target.value)}
                                                    onFocus={(e) => handleFocus(index, 'itemDiscount')}
                                                    onBlur={(e) => handleBlur(index, 'itemDiscount', e.target.value)}
                                                    disabled={disabled}
                                                    onInput={(e) => {
                                                        const inputValue = e.target.value;
                                                        if (!/^(0|[1-9]\d*)(\.\d*)?$/.test(inputValue)) {
                                                            e.target.value = inputValue.slice(0, -1);
                                                        }
                                                    }}
                                                />
                                            </td>

                                            {/* % */}
                                            <td
                                                hidden={window.location.pathname === '/order-product'
                                                    || window.location.pathname === '/picking-list' ? true : false}
                                                className="text-center"
                                            >
                                                <select
                                                    className="form-select"
                                                    value={item.itemDisType || ''}
                                                    onChange={(e) => handleChangeDetail(index, 'itemDisType', e.target.value)}
                                                    disabled={disabled}
                                                >
                                                    <option value="1">฿</option>
                                                    <option value="2">%</option>
                                                </select>
                                            </td>

                                            {/* จำนวนเงินรวม */}
                                            <td
                                                hidden={window.location.pathname === '/order-product'
                                                    || window.location.pathname === '/picking-list' ? true : false}
                                                className="text-end"
                                            >
                                                <span>{formatCurrency(item.itemTotal || 0, true)}</span>
                                            </td>

                                            {/* คลังสินค้า */}
                                            <td className="text-center"
                                                hidden={[
                                                    "/deposit-document",
                                                    "/purchase-request",
                                                    "/purchase-order",
                                                    "/order-product",
                                                    "/picking-list",
                                                    "/billofsale",
                                                    "/bill",
                                                    "/quotation",
                                                    "/taxes"
                                                ]
                                                    .includes(window.location.pathname)
                                                }
                                            >
                                                {(() => {
                                                    return (
                                                        window.location.pathname === '/product-receipt' && mode === 'U' ? (
                                                            <>
                                                                {item.whId ? (
                                                                    whDataList
                                                                        .filter((warehouse) => parseCurrency(warehouse.WH_Id) === parseCurrency(item.whId))
                                                                        .map((warehouse) => (
                                                                            <span key={warehouse.WH_Id}>{warehouse.WH_Name || 'ไม่ระบุคลัง'}</span>
                                                                        ))
                                                                ) : (
                                                                    <span>ไม่ระบุคลัง</span>
                                                                )}
                                                            </>
                                                        ) : (
                                                            <select
                                                                name="whId"
                                                                value={item.whId}
                                                                onChange={(e) => handleChangeDetail(index, 'whId', e.target.value)}
                                                                className="form-select form-control"
                                                                disabled={
                                                                    window.location.pathname === '/product-receipt' ? (!disabled || disabledRec) : disabled
                                                                }
                                                            >
                                                                <option value={''}>กรุณาเลือกคลัง</option>
                                                                {whDataList.map((warehouse) => (
                                                                    <option key={warehouse.WH_Id} value={warehouse.WH_Id}>
                                                                        {warehouse.WH_Name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        )
                                                    );
                                                })()}
                                            </td>

                                            {/* ลบ */}
                                            <td
                                                className="text-center"
                                                hidden={window.location.pathname === '/product-receipt' ? true : false}>
                                                <button
                                                    type="button"
                                                    className="btn btn-danger"
                                                    onClick={() => handleRemoveRow(index)}
                                                    disabled={disabled}
                                                >
                                                    ลบ
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="13">
                                            <center>
                                                <h5>ไม่พบรายการสินค้า</h5>
                                            </center>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                        {/* Modal คลังสินค้า */}
                        <div
                            className={`modal fade ${showWarehouseModal ? 'show' : ''}`}
                            style={{ display: showWarehouseModal ? 'block' : 'none' }}
                            tabIndex="-1"
                            role="dialog"
                        >
                            <div
                                className="modal-dialog modal-lg"
                                style={{ maxWidth: '35%' }}
                                role="document"
                            >
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <div className="d-flex align-items-center">
                                            <h4 className="card-title">คลังสินค้า</h4>
                                        </div>
                                        <button type="button" className="btn-close" onClick={handleWarehouseClose}></button>
                                    </div>
                                    <div className="modal-body">
                                        <div className="table-responsive" style={{ maxHeight: '650px', overflowY: 'auto' }}>
                                            <table className="table table-striped table-hover">
                                                <thead className="thead-dark">
                                                    <tr>
                                                        <th className="text-center" style={{ width: '20%' }}>รหัสคลังสินค้า</th>
                                                        <th className="text-center" style={{ width: '80%' }}>ชื่อคลังสินค้า</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {whDataList && whDataList.length > 0 ? (
                                                        whDataList.map((warehouse, index) => (
                                                            <tr
                                                                key={warehouse.Item_Id || index + 1}
                                                                onClick={() => onRowSelectWh(warehouse)}
                                                                style={{ cursor: 'pointer' }}
                                                            >
                                                                <td className="text-center">{warehouse.WH_Code}</td>
                                                                <td className="text-left">{warehouse.WH_Name}</td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="2">
                                                                <center>
                                                                    <h5>ไม่พบข้อมูล</h5>
                                                                </center>
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button
                                            className="btn btn-lg btn-danger"
                                            onClick={handleWarehouseClose}
                                        >
                                            ปิด
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {showWarehouseModal && <div className="modal-backdrop fade show"></div>}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ItemForSaleTable;